import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { addNewMentor, editStaffMember, getAllStaffMembers } from "../../../redux/features/staff/staffService";
import { showToast } from "../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import Modal from "../../../components/Modal";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import TableSkeleton from "../../../components/Skeleton";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { editUser } from "../../../redux/features/users/userService";
import { faAngleDown, faAngleUp, faClose, faXmark } from "@fortawesome/free-solid-svg-icons";
import SearchBarOnChange from "../../../components/SearchBarOnChange";
import { getAllOrganizations } from "../../../redux/features/organization/organizationService";
import { getAllInterests } from "../../../redux/features/interest/interestService";
import { getAllSkills } from "../../../redux/features/skill/skillService";
import { useNavigate } from "react-router-dom";

const EmplymentType = [
    { id: '1', name: 'FULL_TIME' },
    { id: '2', name: 'PART_TIME' },
]

const Mentor = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const organizationDropdownRef = useRef(null);

    const { isStaffMembersLoading, pageCount, staffMembers } = useSelector((state) => state.staff.allStaffMembers);
    const { isStaffMemberCreating } = useSelector((state) => state.staff.newStaffMember);
    const { isEditingStaffMember } = useSelector((state) => state.staff.editedStaffMember);

    const { isOrganizationsLoading, organizations } = useSelector((state) => state.organization.allOrganizations);
    const { isInterestsLoading, interests } = useSelector((state) => state.interest.allInterests);
    const { isSkillsLoading, skills } = useSelector((state) => state.skill.allSkills);

    const [isExperienceToggled, setExperienceToggled] = useState(false);
    const [isQualificationToggled, setQualificationToggled] = useState(false);

    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        phone_number: "",
        create_mentor_experience_dtos: [],
        create_mentor_qualification_dtos: [],
        interests: [],
        skills: [],
    });

    const [errorMessages, setErrorMessages] = useState({});
    const [disabledBtn, setDisabledBtn] = useState(false);

    const handleArrayInputChange = (index, field, key, value) => {
        const updatedArray = [...formData[field]];
        updatedArray[index][key] = value;

        setFormData((prev) => ({
            ...prev,
            [field]: updatedArray,
        }));
    };

    const addArrayItem = (field, emptyObj) => {
        setFormData((prev) => ({
            ...prev,
            [field]: [...prev[field], emptyObj],
        }));
    };

    const removeArrayItem = (field, index) => {
        const updatedArray = [...formData[field]];
        updatedArray.splice(index, 1);

        setFormData((prev) => ({
            ...prev,
            [field]: updatedArray,
        }));
    };

    const handleToggleInterest = (id) => {
        setFormData((prev) => {
            if (prev.interests.includes(id)) {
                return prev;
            }

            return {
                ...prev,
                interests: [...prev.interests, id]
            };
        });
    };

    const handleRemoveInterest = (id) => {
        setFormData((prev) => ({
            ...prev,
            interests: prev.interests.filter((v) => v !== id)
        }));
    };

    const handleToggleSkill = (id) => {
        setFormData((prev) => {
            if (prev.skills.includes(id)) {
                return prev;
            }

            return {
                ...prev,
                skills: [...prev.skills, id]
            };
        });
    };

    const handleRemoveSkill = (id) => {
        setFormData((prev) => ({
            ...prev,
            skills: prev.skills.filter((v) => v !== id)
        }));
    };

    const [skip, setSkip] = useState(0);

    const limit = 10;  // Number of items per page
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedStaffMember, setSelectedStaffMember] = useState(null);
    const [initialStaffMember, setInitialStaffMember] = useState(null);
    const [editErrorMsgs, setEditErrorMsgs] = useState({
        name: '',
    });
    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const fetchAllStaffMembers = useCallback(() => {
        dispatch(getAllStaffMembers({
            skip: skip,
            limit,
            role_name: 'mentor',
            search: searchQuery,
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        dispatch(getAllOrganizations({}));
        dispatch(getAllInterests({}));
        dispatch(getAllSkills({}));
    }, [dispatch]);

    useEffect(() => {
        fetchAllStaffMembers();
    }, [fetchAllStaffMembers]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidStaffMember = () => {
        const errors = {};
        const trimmedName = formData.full_name.trim();
        if (!trimmedName) {
            errors.full_name = "Name is required.";
        }
        if (!formData.email) {
            errors.email = "Email is required.";
        } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            errors.email = "Invalid email format.";
        }
        if (!formData.phone_number) {
            errors.phone_number = "Phone Number is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const insertNewStaffMember = async () => {
        if (isValidStaffMember()) {
            setDisabledBtn(true);
            try {
                const response = await dispatch(addNewMentor(formData)).unwrap();
                setDisabledBtn(false);
                setFormData({
                    full_name: "",
                    email: "",
                    phone_number: "",
                    create_mentor_experience_dtos: [],
                    create_mentor_qualification_dtos: [],
                    interests: [],
                    skills: [],
                });
                if (roleDropdownRef.current) {
                    roleDropdownRef.current.clearSelection();
                }
                fetchAllStaffMembers();
                showToast('success', response.message);
            }
            catch (error) {
                setDisabledBtn(false);
                showToast('error', error.message);
            };
        }
    };

    // Edit staffMember
    const handleSelectedStaffMemberChange = (e) => {
        const { name, value } = e.target;
        setErrorMsg(null);
        setSelectedStaffMember((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEditErrorMsgs((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const isValidEditStaffMember = () => {
        const errors = {};
        const trimmedName = selectedStaffMember.full_name.trim();

        if (!trimmedName) {
            errors.full_name = "Name is required.";
        }
        if (!selectedStaffMember.phone_number) {
            errors.phone_number = "Phone Number is required.";
        }
        if (Object.keys(errors).length > 0) {
            setEditErrorMsgs(errors);
            return false;
        } else {
            return true;
        }
    };

    function getChangedValues(selectedData) {
        const changedValues = {};
        for (const key in selectedData) {
            if (
                key !== 'id' &&
                selectedData.hasOwnProperty(key) &&
                selectedData[key] !== initialStaffMember[key]
            ) {
                changedValues[key] = selectedData[key];
            }

            if (key === 'id') {
                changedValues[key] = selectedData[key];
            }
        }
        return changedValues;
    }

    const editStaffMemberDetails = async () => {
        if (isValidEditStaffMember(selectedStaffMember)) {
            const data = getChangedValues(selectedStaffMember);
            const hasChanges = Object.keys(data).some(key => key !== 'id');
            if (!hasChanges) {
                setErrorMsg('There are no changes to update.');
            } else {
                setEditBtnDisable(true);
                try {
                    const response = await dispatch(editStaffMember(data)).unwrap();
                    setEditBtnDisable(false);
                    setSelectedStaffMember(null);
                    setInitialStaffMember(null);
                    setModalOpen(false);
                    showToast('success', response.message);
                    fetchAllStaffMembers();
                }
                catch (error) {
                    setEditBtnDisable(false);
                    showToast('error', error.message);
                };
            }
        }
    };

    //Activate StaffMember
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedStaffMemberId, setSelectedStaffMemberId] = useState(null);

    const closeModal = () => setActivateModalOpen(false);
    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        try {
            const response = await dispatch(editUser({ id: selectedStaffMemberId, status: 'Active' })).unwrap();
            setSelectedStaffMemberId(null);
            setInitialStaffMember(null);
            showToast('success', response.message);
            fetchAllStaffMembers();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }
    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(editUser({ id: selectedStaffMemberId, status: 'Deactivated' })).unwrap();
            setSelectedStaffMemberId(null);
            setInitialStaffMember(null);
            showToast('success', response.message);
            fetchAllStaffMembers();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    const handleSearch = (query) => {
        setSearchQuery(query)
        setSkip(0);
    };

    const openMentor = (id) => {
        navigate(`/admin/mentors/${id}`);
    }

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add New Mentor</h1>
                <div className={styles.formContainer}>
                    <form className={styles.coordinatorForm} noValidate>
                        <div className="form-input-row">
                            <div className="form-input-col md-col">
                                <div className="form-input-group">
                                    <label className="form-label">
                                        Full Name<span className="required-star">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="full_name"
                                        value={formData.full_name}
                                        onChange={handleInputChange}
                                        placeholder="Enter Name"
                                        className="form-input-default"
                                    />
                                    {errorMessages.full_name && (
                                        <p className="text-danger">{errorMessages.full_name}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-input-row">
                            <div className="form-input-col md-col">
                                <div className="form-input-group">
                                    <label className="form-label">
                                        Email Address<span className="required-star">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Enter Email"
                                        className="form-input-default"
                                    />
                                    {errorMessages.email && (
                                        <p className="text-danger">{errorMessages.email}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-input-row">
                            <div className="form-input-col md-col">
                                <div className="form-input-group">
                                    <label className="form-label">
                                        Phone Number<span className="required-star">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="phone_number"
                                        value={formData.phone_number}
                                        onChange={handleInputChange}
                                        placeholder="Enter Phone Number"
                                        className="form-input-default"
                                    />
                                    {errorMessages.phone_number && (
                                        <p className="text-danger">{errorMessages.phone_number}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-input-row">
                            <div className="form-input-col md-col">
                                <div className="form-input-group">
                                    <label className="form-label">Interests</label>
                                    <Dropdown
                                        options={interests}
                                        placeholder="Choose Interests"
                                        value=""
                                        onSelect={(selected) => handleToggleInterest(selected.id)}
                                    />
                                    <div className={styles.selectedTags}>
                                        {formData.interests?.map((id) => {
                                            const item = interests.find(i => i.id === id);
                                            return (
                                                <span key={id} className={styles.closetagRow}>
                                                    {item?.name}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveInterest(id)}
                                                        className={styles.removeTag}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleXmark} />
                                                    </button>
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-input-row">
                            <div className="form-input-col md-col">
                                <div className="form-input-group">
                                    <label className="form-label">Interests</label>
                                    <Dropdown
                                        options={skills}
                                        placeholder="Choose Skills"
                                        value=""
                                        onSelect={(selected) => handleToggleSkill(selected.id)}
                                    />
                                    <div className={styles.selectedTags}>
                                        {formData.skills?.map((id) => {
                                            const item = skills.find(i => i.id === id);
                                            return (
                                                <span key={id} className={styles.closetagRow}>
                                                    {item?.name}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveSkill(id)}
                                                        className={styles.removeTag}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleXmark} />
                                                    </button>
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.experienceSec}>
                            <div className={styles.experienceHeader} onClick={() => setExperienceToggled(!isExperienceToggled)}>
                                <h3>Experience {isExperienceToggled ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleUp} />}</h3>
                            </div>
                            {isExperienceToggled &&
                                <div className={styles.experienceExpandSec}>

                                    <button
                                        type="button"
                                        className={`btn-add`}
                                        onClick={() =>
                                            addArrayItem("create_mentor_experience_dtos", {
                                                organization_id: "",
                                                designation: "",
                                                description: "",
                                                start_date: "",
                                                employment_type: "",
                                                is_working: 0,
                                            })
                                        }
                                    >
                                        + Add Experience
                                    </button>
                                    {formData.create_mentor_experience_dtos?.map((exp, index) => (
                                        <div key={index} className={styles.experienceIndex}>
                                            <h4>Experience {index + 1} <FontAwesomeIcon
                                                type="button"
                                                className={`text-danger ${styles.trashBtn}`}
                                                onClick={() =>
                                                    removeArrayItem("create_mentor_experience_dtos", index)
                                                }
                                                icon={faTrashCan}
                                            />
                                            </h4>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Organization</label>
                                                        <Dropdown
                                                            options={organizations}
                                                            placeholder="Choose an Option"
                                                            value={organizations.find(o => o.id === exp.organization_id)?.name || ""}
                                                            onSelect={(selected) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "organization_id",
                                                                    selected.id
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Designation</label>
                                                        <input
                                                            type="text"
                                                            value={exp.designation}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "designation",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            placeholder="Enter the Designation"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Description</label>
                                                        <textarea
                                                            value={exp.description}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "description",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            rows={3}
                                                            placeholder="Describe your role"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Start Date</label>
                                                        <input
                                                            type="date"
                                                            value={exp.start_date}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "start_date",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Employment Type</label>
                                                        <Dropdown
                                                            options={EmplymentType}
                                                            placeholder="Choose Employment Type"
                                                            value={EmplymentType.find(t => t.name === exp.employment_type)?.name || ""}
                                                            onSelect={(selected) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "employment_type",
                                                                    selected.name
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className={`form-input-group ${styles.labelRow}`}>
                                                        <label className="form-label">Currently Working?</label>
                                                        <input
                                                            type="checkbox"
                                                            checked={exp.is_working === 1}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_experience_dtos",
                                                                    "is_working",
                                                                    e.target.checked ? 1 : 0
                                                                )
                                                            }
                                                            className={styles.workCheckBox}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                        <div className={styles.experienceSec}>
                            <div className={styles.experienceHeader} onClick={() => setQualificationToggled(!isQualificationToggled)}>
                                <h3>Qualification {isQualificationToggled ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleUp} />}</h3>
                            </div>
                            {isQualificationToggled &&
                                <div className={styles.experienceExpandSec}>
                                    <button
                                        type="button"
                                        className={`btn-add`}
                                        onClick={() =>
                                            addArrayItem("create_mentor_qualification_dtos", {
                                                school_or_university: "",
                                                degree_or_certificate: "",
                                                field_of_study: "",
                                                description: "",
                                                start_date: "",
                                                end_date: ""
                                            })
                                        }
                                    >
                                        + Add Qualification
                                    </button>
                                    {formData.create_mentor_qualification_dtos?.map((q, index) => (
                                        <div key={index} className={styles.experienceIndex}>
                                            <h4>Qualification {index + 1} <FontAwesomeIcon
                                                type="button"
                                                className={`text-danger ${styles.trashBtn}`}
                                                onClick={() =>
                                                    removeArrayItem("create_mentor_qualification_dtos", index)
                                                }
                                                icon={faTrashCan}
                                            />
                                            </h4>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">University / School</label>
                                                        <input
                                                            type="text"
                                                            value={q.school_or_university}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "school_or_university",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            placeholder="Enter University or School"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Degree / Certificate</label>
                                                        <input
                                                            type="text"
                                                            value={q.degree_or_certificate}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "degree_or_certificate",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            placeholder="Enter Degree or Certificate"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Field of Study</label>
                                                        <input
                                                            type="text"
                                                            value={q.field_of_study}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "field_of_study",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            placeholder="Enter Field of Study"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Description</label>
                                                        <textarea
                                                            value={q.description}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "description",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                            rows={3}
                                                            placeholder="Add any details about this qualification"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">Start Date</label>
                                                        <input
                                                            type="date"
                                                            value={q.start_date}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "start_date",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-input-row">
                                                <div className="form-input-col md-col">
                                                    <div className="form-input-group">
                                                        <label className="form-label">End Date</label>
                                                        <input
                                                            type="date"
                                                            value={q.end_date}
                                                            onChange={(e) =>
                                                                handleArrayInputChange(
                                                                    index,
                                                                    "create_mentor_qualification_dtos",
                                                                    "end_date",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="form-input-default"
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                        <button
                            className="btn-primary"
                            type="button"
                            disabled={disabledBtn}
                            onClick={insertNewStaffMember}
                        >
                            {isStaffMemberCreating ? <span>Loading...</span> : `Create`}
                        </button>
                    </form>
                </div>
            </div>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Mentors</h1>
                    <SearchBarOnChange
                        value={searchQuery}
                        onSearch={handleSearch}
                    />
                </div>
                <div className={`search-card-body`}>
                    {isStaffMembersLoading ?
                        <TableSkeleton columns={["Full Name", "Email", "Role", "Status", "Actions"]} rowCount={10} height={20} />
                        : staffMembers.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Full Name</th>
                                            <th>Email</th>
                                            <th>Phone Number</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {staffMembers?.map((staffMember) => (
                                            <tr key={staffMember.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {staffMember.full_name}
                                                </td>
                                                <td>{staffMember.email}</td>
                                                <td>{staffMember.phone_number}</td>
                                                <td>{staffMember.status}</td>
                                                <td className={`actionsBtn`}>
                                                    <button
                                                        className={staffMember.status === 'Active' ? `btn-inactive` : `btn-active`}
                                                        onClick={() => {
                                                            setSelectedStaffMemberId(staffMember.id);
                                                            staffMember.status === 'Active' ? setDeactivationModalOpen(true) : setActivateModalOpen(true);
                                                        }
                                                        }>{staffMember.status === 'Active' ? 'Deactivate' : 'Acitvate'}</button>
                                                    <button className={`view-btn`} onClick={() => openMentor(staffMember.id)}>View</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Edit Staff Member</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div className={styles.formContainer}>
                                <form
                                    className={styles.coordinatorForm}
                                    noValidate
                                >
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Name<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='full_name'
                                                name='full_name'
                                                value={selectedStaffMember.full_name || ''}
                                                onChange={handleSelectedStaffMemberChange}
                                                placeholder='Enter StaffMember Name'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.full_name && (
                                                <p className={`text-danger`}>{editErrorMsgs.full_name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Email<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='email'
                                                name='email'
                                                value={selectedStaffMember.email || ''}
                                                disabled
                                                placeholder='Enter Email'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.email && (
                                                <p className={`text-danger`}>{editErrorMsgs.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Phone Number<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='phone_number'
                                                name='phone_number'
                                                value={selectedStaffMember.phone_number || ''}
                                                onChange={handleSelectedStaffMemberChange}
                                                placeholder='Enter Phone Number'
                                                className={`form-input-default`}
                                            />
                                            {editErrorMsgs.phone_number && (
                                                <p className={`text-danger`}>{editErrorMsgs.phone_number}</p>
                                            )}
                                            {errorMsg && (
                                                <p className={`text-danger`}>{errorMsg}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={editStaffMemberDetails}
                                    >
                                        {isEditingStaffMember ? <BeatLoader color='#ffffff' /> : `Save`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isActivateModalOpen && (
                <Modal
                    title='Staff Member Activation'
                    onClose={closeModal}
                    onYes={handleYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to activate the Staff Member?`}
                    colorType={`var(--green)`}
                />
            )}
            {isDeactivationModalOpen && (
                <Modal
                    title='Staff Member Deactivation'
                    onClose={closDeactivationModal}
                    onYes={handleRejectYes}
                    isInput={false}
                    iconName={faCircleXmark}
                    bodyText={`Are you sure you want to deactivate the Staff Member?`}
                    colorType={`var(--danger)`}
                />
            )}
        </div>
    );
};

export default Mentor;